import { Container, Row, Col } from 'react-bootstrap';
import FlickrAlbum from './flickr-album';

interface AlbumData {
  event: string;
  venue: string;
  href: string;
  imageurl: string;
}

const albums: AlbumData[] = [
  {
    event: 'Spring Meeting 2019',
    venue: 'Warley Park',
    href: 'https://www.flickr.com/photos/clambden/albums/72157708013549764',
    imageurl: 'https://live.staticflickr.com/7892/32606648287_d13d95ac94_n.jpg',
  },
  {
    event: "Captain's Trophy 2018",
    venue: 'Surrey National',
    href: 'https://www.flickr.com/photos/clambden/albums/72157704217155272',
    imageurl: 'https://farm8.staticflickr.com/7892/46732971124_2bd55b6d2b_n.jpg',
  },
  {
    event: 'Summer Tour 2018',
    venue: 'The Wiltshire',
    href: 'https://www.flickr.com/photos/clambden/albums/72157699962223124',
    imageurl: 'https://farm2.staticflickr.com/1815/42287586550_d323f92408_n.jpg',
  },
  {
    event: 'Summer Tour 2017',
    venue: 'La Manga',
    href: 'https://www.flickr.com/photos/clambden/albums/72157683809482936',
    imageurl: 'https://c1.staticflickr.com/5/4181/34319505950_6e9dc512e2_n.jpg',
  },
  {
    event: 'Summer Tour 2013',
    venue: 'Dale Hill',
    href: 'https://www.flickr.com/photos/clambden/albums/72157634830487418',
    imageurl: 'https://c1.staticflickr.com/4/3781/9385181798_7afba44331_n.jpg',
  },
  {
    event: 'Summer Tour 2012',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157667286132349',
    imageurl: 'https://farm5.staticflickr.com/4647/38925535402_20b3be1616_n.jpg',
  },
  {
    event: 'Summer Tour 2011',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157627318635785',
    imageurl: 'https://c1.staticflickr.com/7/6202/6047900570_a8300c4b1b_z.jpg',
  },
  {
    event: 'Summer Tour 2010',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157627225198087',
    imageurl: 'https://c1.staticflickr.com/7/6022/6005948457_3f5093373a_n.jpg',
  },
  {
    event: 'Summer Tour 2009',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157627349425218',
    imageurl: 'https://c1.staticflickr.com/7/6089/6046863971_e23a5e7c77_n.jpg',
  },
  {
    event: 'Summer Tour 2008',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157627225183307',
    imageurl: 'https://c1.staticflickr.com/7/6007/6006395838_678521dd8b_n.jpg',
  },
  {
    event: 'Summer Tour 2007',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157627224918907',
    imageurl: 'https://c1.staticflickr.com/7/6018/6005701541_12a8ba47cd_n.jpg',
  },
  {
    event: 'Summer Tour 2005',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157627224919799',
    imageurl: 'https://c1.staticflickr.com/7/6130/6005848505_95a697eb8d_n.jpg',
  },
  {
    event: 'Summer Tour 2004',
    venue: 'Dartmouth',
    href: 'https://www.flickr.com/photos/clambden/albums/72157627349091078',
    imageurl: 'https://c1.staticflickr.com/7/6006/6006226642_d050ee4e15_n.jpg',
  },
];

export default function GalleryPage() {
  return (
    <Container fluid>
      <Row className="g-0">
        {albums.map((album) => (
          <Col key={album.href} xl={4}>
            <FlickrAlbum event={album.event} venue={album.venue} href={album.href} imageurl={album.imageurl} />
          </Col>
        ))}
      </Row>
    </Container>
  );
}
